import { InfringementAlertPage, ThankyouPage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/infringement-alert',
        element: InfringementAlertPage
    },
    {
        path: '/thankyou',
        element: ThankyouPage
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
